import { addNotas } from "data/apiConection.js/dataNotas";
import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import PropTypes from "prop-types";
import { dataCursosById } from "data/apiConection.js/dataCursos";

const FormNota = ({ alumno_id, alumno, setFlagAddNota, flagAddNota }) => {
  const [validated, setValidated] = useState(false);
  const [curso, setCurso] = useState(null);
  const [formData, setFormData] = useState({
    subject: "",
    grade: "",
    observations: "",
  });

  const materiasPorNivel = {
    "5º AÑO": ["Reading", "Writing", "Use of English", "Listening", "Speaking"],
    "6º AÑO": ["Reading", "Writing", "Use of English", "Listening", "Speaking"],
    "3º AÑO": ["Reading", "Writing", "Listening", "Speaking"],
    "4º AÑO": ["Reading", "Writing", "Listening", "Speaking"],
    "1º AÑO": ["Reading and Writing", "Listening", "Speaking"],
    "2º AÑO": ["Reading and Writing", "Listening", "Speaking"],
    "KIDS 1": ["Reading and Writing", "Listening", "Speaking"],
    "TEENS": ["Reading and Writing", "Listening", "Speaking"],
    "PREPARATORIO 1": ["Listening", "Speaking"],
    "PREPARATORIO 2": ["Listening", "Speaking"],
    "KINDER": ["Listening", "Speaking"],
    "DEFAULT":["Reading","Writing","Use of English","Listening","Speaking","Reading and Writing"]
  };

  useEffect(() => {
    if (alumno && alumno.curso_id) {
      const fetchCurso = async () => {
        try {
          const cu = await dataCursosById(alumno.curso_id);
          setCurso(cu[0]);
        } catch (error) {
          console.error("Error fetching curso by id!", error.message);
        }
      };
      fetchCurso();
    }
  }, [alumno?.curso_id]);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      event.preventDefault();
      try {
        const response = await addNotas(alumno_id, formData);
        if (response.message === "Nota created successfully!") {
          setFlagAddNota(!flagAddNota);
        }
      } catch (error) {
        console.error("Error adding nota:", error.message);
      }
    }
    setValidated(true);
  };

  const mapOptions = (materias) =>
    materias.map((materia) => (
      <option key={materia} value={materia}>
        {materia}
      </option>
    ));
  return (
    <Card className="p-4">
      <Card.Body>
        <Card.Title className="mb-4">Formulario de Registro de Nota</Card.Title>
        {curso && (
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Row className="mb-3">
              <Form.Group as={Col} md="6" controlId="subject">
                <Form.Label>Materia</Form.Label>
                <Form.Select
                  required
                  value={formData.subject}
                  onChange={handleInputChange}
                >
                  <option value="">Seleccione una materia</option>
                  {materiasPorNivel[curso.nivel]
                    ? mapOptions(materiasPorNivel[curso.nivel])
                    : mapOptions(materiasPorNivel['DEFAULT'])}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  Por favor, seleccione la materia.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md="6" controlId="grade">
  <Form.Label>Nota</Form.Label>
  {curso &&
  (curso.nivel === "KINDER" || 
   curso.nivel === "PREPARATORIO 1" || 
   curso.nivel === "PREPARATORIO 2") ? (
    <Form.Select
      required
      value={formData.grade}
      onChange={handleInputChange}
    >
      <option value="">Seleccione una calificación</option>
      <option value="10">Sobresaliente</option>
      <option value="8">Muy Bien</option>
      <option value="7">Bien</option>
      
    </Form.Select>
  ) : (
    <Form.Control
      required
      type="number"
      placeholder="Nota"
      value={formData.grade}
      onChange={handleInputChange}
      min="0"
      max="10"
      step="0.01"
    />
  )}
  <Form.Control.Feedback type="invalid">
    {curso && 
    (curso.nivel === "KINDER" || 
     curso.nivel === "PREPARATORIO 1" || 
     curso.nivel === "PREPARATORIO 2")
      ? "Por favor, seleccione una calificación."
      : "Por favor, ingrese una nota válida entre 0 y 10."
    }
  </Form.Control.Feedback>
</Form.Group>

              <Form.Group as={Col} md="12" controlId="observations">
                <Form.Label>Observaciones</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Observaciones"
                  value={formData.observations}
                  onChange={handleInputChange}
                />
                <Form.Control.Feedback type="invalid">
                  Por favor, ingrese las observaciones.
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <div className="d-grid gap-2 mt-4">
              <Button type="submit" size="lg">
                Enviar Nota
              </Button>
            </div>
          </Form>
        )}
      </Card.Body>
    </Card>
  );
};

FormNota.propTypes = {
  alumno_id: PropTypes.number,
  alumno: PropTypes.object,
  setFlagAddNota: PropTypes.func,
  flagAddNota: PropTypes.bool,
};

export default FormNota;
